import React from "react";

export default class BeschichtungsAuswahl extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    this.props.setBeschichtung(e.target.value);
  }

  render() {
    return (
      <div>
        <select id="folientyp" onChange={this.handleChange}>
          <option value="Matt">Matt</option>
          <option value="Glänzend">Glänzend</option>
        </select>
      </div>
    );
  }
}
